/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SlackConnectionStatusDto = {
    status: SlackConnectionStatusDto.status;
    workspaceName?: string;
};

export namespace SlackConnectionStatusDto {

    export enum status {
        CONNECTED = 'CONNECTED',
        DISCONNECTED = 'DISCONNECTED',
        REMOVED = 'REMOVED',
    }


}
